/***********************
 * TOGGLE CARD/TABLE VIEW (Reporting)
 ************************/

import PropTypes from "prop-types"
import React, { useState } from "react"

import { Switch } from "antd"

import { Form, Nav, NavItem, NavLink, Tooltip } from "reactstrap"

//Classnames
import classnames from "classnames"

// Locale
import { withTranslation } from "react-i18next"

const CardTableToggle = props => {
  // Filter view related states
  const [activeTab, setActiveTab] = useState("1")
  // Tooltip states
  const [tTnavcardtop, setTTnavcardtop] = useState(false)
  const [tTnavtabletop, setTTnavtabletop] = useState(false)

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)

      props.setWidgetVisible(!props.widgetVisible)
      props.setTableVisible(!props.tableVisible)
    }
  }
  return (
    <React.Fragment>
      <div className="float-end">
        <Form>
          <Nav className="product-view-nav" pills>
            {props.hideSwitch && (
              <NavItem>
                <div className="mt-2 me-2 d-flex align-items-center">
                  {props.t("Hide calls under 1 minute")}
                  <Switch
                    className="ms-2 d-block"
                    name="hideShortCalls"
                    checked={props.hideShortCalls}
                    onChange={v => {
                      props.setHideShortCalls(v)
                    }}
                  />
                </div>
              </NavItem>
            )}
            <NavItem>
              {/* Card view */}
              <Tooltip
                placement="bottom"
                isOpen={tTnavcardtop}
                target="TTnavcardservice"
                toggle={() => {
                  setTTnavcardtop(!tTnavcardtop)
                }}
              >
                {props.t("Cards")}
              </Tooltip>
              <NavLink
                id="TTnavcardservice"
                className={classnames({
                  active: activeTab === "1",
                })}
                onClick={() => {
                  toggleTab("1")
                }}
              >
                <i
                  style={{ padding: "10px" }}
                  className="bx bx-grid-alt text-size-16"
                />
              </NavLink>
            </NavItem>
            <NavItem>
              {/* Table view */}
              <Tooltip
                isOpen={tTnavtabletop}
                target="TTnavtableservice"
                placement="bottom"
                toggle={() => {
                  setTTnavtabletop(!tTnavtabletop)
                }}
              >
                {props.t("Table")}
              </Tooltip>
              <NavLink
                id="TTnavtableservice"
                className={classnames({
                  active: activeTab === "2",
                })}
                onClick={() => {
                  toggleTab("2")
                }}
              >
                <i
                  style={{ padding: "10px" }}
                  className="bx bx-list-ul text-size-16"
                />
              </NavLink>
            </NavItem>
          </Nav>
        </Form>
      </div>
    </React.Fragment>
  )
}

CardTableToggle.propTypes = {
  t: PropTypes.any,
  hideSwitch: PropTypes.any,
  setWidgetVisible: PropTypes.any,
  setTableVisible: PropTypes.any,
  widgetVisible: PropTypes.any,
  tableVisible: PropTypes.any,
  hideShortCalls: PropTypes.any,
  setHideShortCalls: PropTypes.any,
}
export default withTranslation()(CardTableToggle)
